import { render, staticRenderFns } from "./PurchasePlanList.vue?vue&type=template&id=019383f8&scoped=true&"
import script from "./PurchasePlanList.vue?vue&type=script&lang=js&"
export * from "./PurchasePlanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019383f8",
  null
  
)

export default component.exports